/** Bounded map that bulk-clears on overflow. */
export class BoundedCache {
    map_ = new Map();
    max_;
    constructor(max = 512) {
        this.max_ = max;
    }
    get(key) {
        return this.map_.get(key);
    }
    set(key, value) {
        if (!this.map_.has(key) && this.map_.size >= this.max_)
            this.map_.clear();
        this.map_.set(key, value);
    }
}
//# sourceMappingURL=boundedCache.js.map